import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type SetRestaurantSettlementIdeaResult =
	| { success: true; errors: null }
	| { success: false; errors: MutationHandlerError }

// Merkt eine Kombination aus Restaurant und Gemeinde oder entfernt sie; die Ideenliste lädt danach neu.
const setRestaurantSettlementIdea = async ({
	slug,
	settlementId,
	marked,
}: {
	slug: string
	settlementId: string
	marked: boolean
}): Promise<SetRestaurantSettlementIdeaResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation SetRestaurantSettlementIdea(
					$slug: String!
					$settlementId: ID!
					$marked: Boolean!
				) {
					setRestaurantSettlementIdea(slug: $slug, settlementId: $settlementId, marked: $marked) {
						success
						error
					}
				}
			`,
			variables: { slug, settlementId, marked },
			refetchQueries: ['RestaurantSettlementIdeas'],
			awaitRefetchQueries: true,
			errorPolicy: 'all',
		})

		if (errors) return { success: false, errors }
		const result = data?.setRestaurantSettlementIdea
		if (!result?.success) {
			return { success: false, errors: result?.error || 'Speichern fehlgeschlagen' }
		}
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default setRestaurantSettlementIdea
